import { compose, prop } from 'ramda';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getSellers = compose(prop('sellers'), getRoot);
